import { Component, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material';
import {AddPopupComponent} from '../Popups/add-popup/add-popup.component';
import { MobileNavService } from '../../shared/services/mobile-nav.service';

@Component({
  selector: 'app-supplier-list',
  templateUrl: './supplier-list.component.html',
  styleUrls: ['./supplier-list.component.css']
})
export class SupplierListComponent implements OnInit {

  constructor(public dialog: MatDialog,
              public mobileNav: MobileNavService) { }

  openDialog(): void {
    let dialogRef = this.dialog.open(AddPopupComponent, {
      width: '250px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

   onClickMe() {
        this.mobileNav.showSideNav();
    }


  ngOnInit() {
  }

}
